export default "__VITE_ASSET__B_$ri1R___ 640w, __VITE_ASSET__yclzeTl9__ 1024w, __VITE_ASSET__CCrh3vhy__ 1280w";